export default {
  email: null,
  feedback: [],
  reports: null
};
